// extracted by mini-css-extract-plugin
export default {"hover":"EditJob_hover__HaStP","blackHover":"EditJob_blackHover__L8Jio","opacityHover":"EditJob_opacityHover__CpIuw"};